import { FC, useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import SalesChannelContainer from "@app/containers/salesChannel";
import { RoutePaths } from "@app/routes/index";
import { getSalesChannelById } from "@app/services/Endpoints/SalesChannel.API";
import { SalesChannels } from "@app/types/SalesChannel.types";

const EditSalesChannelPage: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [editSalesChannel, setEditSalesChannel] = useState<SalesChannels>();

    const fetchSalesChannelById = useCallback((id: string) => {
        getSalesChannelById(id)
            .then((res) => {
                setEditSalesChannel(res?.data?.data);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        if (!location.state?.salesChannelEditData) {
            navigate(RoutePaths.ViewSalesChannels);
        } else {
            fetchSalesChannelById(location.state?.salesChannelEditData.id);
        }
    }, [location.state, navigate, fetchSalesChannelById]);

    return <SalesChannelContainer salesChannel={editSalesChannel} />;
};

export default EditSalesChannelPage;
